import React, { useEffect, useState } from 'react';

import { t } from 'i18next';
import { BackgroundColorTheme } from '../../templates/Page';
import { clsx, withDataLayer, withGtag } from '../../utils/utils';
import Button from './Button';
import * as styles from './CookiesBanner.module.scss';

export const LOCAL_STORAGE_ENTRY = 'consentMode';

interface CookiesBannerProps {
  textContent: React.ReactNode;
  theme?: BackgroundColorTheme;
  className?: string;
}

const CookiesBanner = ({
  textContent,
  theme,
  className,
}: CookiesBannerProps): React.ReactElement => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    const consentMode = window.localStorage.getItem(LOCAL_STORAGE_ENTRY);
    if (!consentMode) {
      setHidden(false);
    }
  }, []);

  function saveConsent(consentGranted: boolean) {
    const consentMode = {
      ad_storage: consentGranted ? 'granted' : 'denied',
      ad_user_data: consentGranted ? 'granted' : 'denied',
      ad_personalization: consentGranted ? 'granted' : 'denied',
      analytics_storage: consentGranted ? 'granted' : 'denied',
      functionality_storage: consentGranted ? 'granted' : 'denied',
      personalization_storage: consentGranted ? 'granted' : 'denied',
      security_storage: consentGranted ? 'granted' : 'denied',
    };
    withGtag(gtag => {
      gtag('consent', 'update', consentMode);
    });
    withDataLayer(dataLayer => {
      dataLayer.push({ event: 'consent_updated' });
    });
    window.localStorage.setItem(LOCAL_STORAGE_ENTRY, JSON.stringify(consentMode));
    setHidden(true);
  }

  return (
    <div className={clsx(styles.container, hidden && styles.hidden, className)} data-theme={theme}>
      <div className={styles.innerContainer}>
        <div className={styles.content}>{textContent}</div>
        <div className={styles.buttonsWrapper}>
          <Button className={clsx(styles.button, styles.accept)} onClick={() => saveConsent(true)}>
            {t('cookie_banner.accept', 'Accept')}
          </Button>
          <a className={clsx(styles.button, styles.decline)} onClick={() => saveConsent(false)}>
            {t('cookie_banner.refuse', 'Refuse')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
